import * as React from 'react';
import { Field, FieldProps } from '../Field';
import { Select, SelectProps } from './Select';

export type SelectFieldProps = FieldProps & SelectProps;

/**
 * `SelectField` is a composition of `Field` component and `Select` component. If you need extra customization, you can compose them yourself.
 *  Ref will be forwarded to the underlying `<select>` element.
 */
export const SelectField = React.forwardRef<HTMLSelectElement, SelectFieldProps>(function SelectFieldComp(
  {
    label,
    wrapperClassName,
    status,
    maxWidth,
    compact,
    helpText,
    alwaysShowHelpText,
    errorHelpText,
    tooltip,
    tooltipAvoidPositions,
    ...selectProps
  },
  ref
) {
  return (
    <Field
      status={status}
      label={label}
      maxWidth={maxWidth}
      wrapperClassName={wrapperClassName}
      compact={compact}
      alwaysShowHelpText={alwaysShowHelpText}
      helpText={helpText}
      errorHelpText={errorHelpText}
      required={selectProps.required}
      inputId={selectProps.id}
      tooltip={tooltip}
      tooltipAvoidPositions={tooltipAvoidPositions}
      renderInput={({ getInputProps }) => <Select {...getInputProps(selectProps)} ref={ref} />}
    />
  );
});
